<script setup>
import { useResizeObserver } from '@vueuse/core'
import HandyScroll from 'vue-handy-scroll'

const el = ref(null)
const inner = ref(null)
const hideHandyScroll = ref(false)

async function updateHandyScroll() {
  HandyScroll.EventBus.emit('update', { sourceElement: el.value })
  const outerWidth = el.value.getBoundingClientRect().width
  const innerWidth = inner.value.getBoundingClientRect().width
  hideHandyScroll.value = outerWidth === innerWidth
}

useResizeObserver(el, (entries) => {
  updateHandyScroll()
})
</script>

<template>
  <div
    ref="el"
    class="desktop-scroll-container"
  >
    <HandyScroll
      class="scrollbar-radius-4 scrollbar-w-8px scrollbar scrollbar-rounded"
      :class="{ 'handy-scroll-hide': hideHandyScroll }"
    >
      <div
        ref="inner"
        class="desktop-scroll-container-inner"
      >
        <slot />
      </div>
    </HandyScroll>
  </div>
</template>

<style lang="scss" scoped>
:deep(.handy-scroll) {
  --scrollbar-track: #ffffff00;
  --scrollbar-thumb: rgba(0, 0, 0, 0.5);
  --scrollbar-width: 8px;
  --scrollbar-height: 7px;
  --scrollbar-track-radius: 1rem;
  --scrollbar-thumb-radius: 1rem;

  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track) !important;
  bottom: 0;

  &::-webkit-scrollbar-track {
    background: var(--scrollbar-track);
  }
  &::-webkit-scrollbar-thumb {
    background: var(--scrollbar-thumb);
  }
  &::-webkit-scrollbar {
    width: var(--scrollbar-width);
    height: var(--scrollbar-height);
  }

  &::-webkit-scrollbar-track {
    border-radius: var(--scrollbar-track-radius);
  }
  &::-webkit-scrollbar-thumb {
    border-radius: var(--scrollbar-thumb-radius);
  }
}

:deep(.handy-scroll-hide) {
  .handy-scroll {
    bottom: 9999px;
  }
}
</style>
